import { render, staticRenderFns } from "./UiButtonGroup.vue?vue&type=template&id=7e3b7796&scoped=true"
var script = {}
import style0 from "./UiButtonGroup.vue?vue&type=style&index=0&id=7e3b7796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b7796",
  null
  
)

export default component.exports